import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core"
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap"
import { Observable, Subscription } from "rxjs"
import { PremiumCollectionOfResource } from "../../../models/collection/premiumCollectionOfResource.model"
import { PremiumResourcePageLinkOption } from "../../../models/collection/premiumResourcePageLinkOption.model"
import { UserService } from "../../../services/user.service"
import { AddOnViewService } from "../../../services/add-on-view.service"
import { PreviewService } from "../../../services/preview.service"

@Component({
    selector: "app-collections-dropdown",
    templateUrl: "./collections-dropdown.component.html",
    styleUrls: ["./collections-dropdown.component.scss"],
    standalone: false,
})
export class CollectionsDropdownComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() public primaryCollection: PremiumCollectionOfResource
    @Input() public linksOptions: PremiumResourcePageLinkOption[]
    private subs: Subscription[] = []
    public isInPreviewMode$: Observable<boolean>

    @ViewChild(NgbDropdown) dropdown: NgbDropdown

    public isDropdownOpen = false

    constructor(
        public userService: UserService,
        public addOnService: AddOnViewService,
        private previewService: PreviewService
    ) {}

    ngOnInit() {
        this.isInPreviewMode$ = this.previewService.previewOnResource$
    }

    ngAfterViewInit() {
        const dropdownSub = this.dropdown.openChange.subscribe(
            (isOpen: boolean) => (this.isDropdownOpen = isOpen)
        )

        this.subs.push(dropdownSub)
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => sub.unsubscribe())
    }
}
